import { steps } from '@/mocks/siteInfo';

export default function StepsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-guide-line text-sm"></i>
            快速上手
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            四步开始您的漫画之旅
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm">
            从找到入口到开始阅读，只需简单四步
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[calc(12.5%+24px)] right-[calc(12.5%+24px)] h-0.5 bg-background-300/60"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step) => (
              <div key={step.step} className="relative text-center group">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-background-50 border-2 border-primary-200 group-hover:border-primary-500 group-hover:bg-primary-500 transition-all duration-300 mb-5 relative z-10">
                  <span className="text-xl font-heading font-bold text-primary-600 group-hover:text-background-50 transition-colors">
                    {step.step}
                  </span>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-10">
          <a
            href="#latest-address"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-rocket-line"></i>
            立即开始
          </a>
        </div>
      </div>
    </section>
  );
}